import * as React from "react";
import { BaseDict } from "../../../dict";

export const renderStartTime = (eventTime: string, dict: BaseDict, componentPrefix: string) =>
    <div className={`rj-ev-list__${componentPrefix}__start-time`}>
        <span className={`rj-ev-list__${componentPrefix}__start`}>{dict.StartedAt}</span>
        <span className={`rj-ev-list__${componentPrefix}__time`}>{eventTime}</span>
    </div>